import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; 
import { motion } from 'framer-motion';

// Pulls the video id out of a youtu.be/ or youtube.com/watch?v= link
const getYouTubeId = (url) => {
  const match = /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([\w-]{11})/.exec(url || '');
  return match ? match[1] : null;
};

function GameDetailView({ game, embedded = false }) {
  /*const { name } = useParams();
  const game = games.find(g => g.name === name);*/

  const navigate = useNavigate();

  // Only build slides for links we can actually embed, so games with
  // placeholder URIs don't get an empty player in the carousel
  const youTubeIds = (game.video || [])
    .map(video => getYouTubeId(video?.uri))
    .filter(Boolean);

  const slides = [
    <div key="thumbnail">
      <img src={game.thumbnail} alt={game.name} />
    </div>,
    ...youTubeIds.map((id, index) => (
      <div key={id} className="detail-video">
        <iframe
          src={`https://www.youtube.com/embed/${id}?rel=0&modestbranding=1`}
          title={`${game.name} gameplay video${youTubeIds.length > 1 ? ` ${index + 1}` : ''}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          loading="lazy"
        ></iframe>
      </div>
    ))
  ];

  return (
    <>
      <motion.div
      className={embedded ? 'detail-view detail-view-embed' : 'detail-view'}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      >
        {!embedded && (
          <button className="back-button" onClick={() => navigate("/games")}>
          ← Back to Games
          </button>
        )}
      
        <div className="detail-content">
          <div className="detail-text">
            <h2>{game.name}</h2>
            
            <Carousel
              swipeable
              emulateTouch
              swipeScrollTolerance={120}
            >
              {slides}
            </Carousel>
            {/*<motion.img
              src={game.image?.[0]?.uri || game.thumbnail}
              alt={game.name}
              className="detail-image"
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2 }}
            />*/}
            <div className="detail-meta">
              <span className="category-tag">{game.category || 'General'}</span>
              <span className="duration">{game.duration || 'Flexible'}</span>
              <span className="difficulty">
                {game.inputDegree ? 
                  ['Easy', 'Medium', 'Hard'][game.inputDegree - 1] : 
                  game.difficulty || 'Various'
                }
              </span>
            </div>
          
            <p className="full-description">{game.description}</p>
          
            <div className="detail-section">
              <h3>Game Specifications</h3>
              <div className="specs-grid">
                <div>
                  <h4>Player Count</h4>
                  <p>{game.playerCount || 1}</p>
                </div>
                <div>
                  <h4>Robot Support</h4>
                  <p>{game.robotSupport ? 'Yes' : 'No'}</p>
                </div>
                <div>
                  <h4>Cognitive Difficulty</h4>
                  <p>{game.cognitiveDifficulty || 'N/A'}</p>
                </div>
                <div>
                  <h4>Motor Difficulty</h4>
                  <p>{game.motorDifficulty || 'N/A'}</p>
                </div>
              </div>
            </div>
          
            <div className="detail-section">
              <h3>Game Metrics</h3>
              <ul>
                {(game.metrics || ['Not measured']).map((metric, i) => (
                  <li key={i}>{metric.replace(/_/g, ' ')}</li>
                ))}
              </ul>
            </div>
          
            <div className="detail-section">
              <h3>Tags</h3>
              <div className="tags-container">
                {(game.tags || []).map((tag, i) => (
                  <span key={i} className="game-tag">{tag}</span>
                ))}
              </div>
            </div>

            <div className="detail-section">
              <h3>Last Updated</h3>
              <p>{game.lastUpdated || 'Unknown'}</p>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
}

export default GameDetailView;